import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {ErrorService, EventService, StatusResponse} from '..';
import {ConfigService} from './config.service';
import {TelemetryEventsByDay, TelemetryResponse} from '../models';


@Injectable({providedIn: 'root'})
export class TelemetryService {
  private baseURL = ConfigService.getApiEndpoint() +'v1/';

  constructor(
    private http: HttpClient,
    private eventService: EventService,
    private error: ErrorService
  ) { }

  getTelemetryForProject(projectId: string, search: String[], query: any): Observable<TelemetryResponse> {
    return this.http.post<TelemetryResponse>(this.baseURL + 'telemetry/project/' + projectId, search, { params: query }).pipe(
      catchError(this.error.handleError('getTelemetryForProject', null))
    );
  }

  getTelemetryForPlayer(projectId: string, playerId: string, query: any): Observable<TelemetryResponse> {
    return this.http.get<TelemetryResponse>(this.baseURL + 'telemetry/project/' + projectId + '/player/' + playerId, { params: query }).pipe(
      catchError(this.error.handleError('getTelemetryForPlayer', null))
    );
  }

  getAllTelemetryEventTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.baseURL + 'telemetry/eventtypes').pipe(
        catchError(this.error.handleError('getAllTelemetryEventTypes', null))
    );
  }

  deleteTelemetryEvents(projectId: string, ids: any): Observable<StatusResponse> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('projectId', projectId);
    if (ids && ids instanceof Array) {
      ids.forEach(id => {
        httpParams = httpParams.append('id', id);
      });
    }

    return this.http.delete<StatusResponse>(this.baseURL + 'telemetry?' + httpParams.toString()).pipe(
        catchError(this.error.handleError('deleteTelemetryEvents', null))
    );
  }

}
